import { CiSet } from "../utils/CiSet"

// This is a special and reserved slug. It shows a care-group-like page where
// you can search for a new GP somewhere in the Netherlands.
export const NATIONAL_SLUG = "nederland"

// Our own name, shown wherever there is no care group or practice to brand a
// message with: the sender of system emails, and the care group placeholder in
// their templates.
export const PRODUCT_NAME = "MijnPraktijk"

const RESERVED_DOMAINS_ARRAY = [
  // Reserved subdomains.
  // NOTE: Certain domains (such as "hadoks" are allowed, because it is an
  // actual slug in our system)
  //
  // These can be found in our Route53 overview
  // https://us-east-1.console.aws.amazon.com/route53/v2/hostedzones?region=eu-central-1#ListRecordSets/Z08507333TEGXLKIS22B8
  "www",
  "api",
  "api.dev",
  "api.staging",
  "dev",
  "development",
  "acc",
  "prod",
  "production",
  "staging",
  "mijnpraktijk",
  "meet",
  "sentry",
  "storybook",
  "autodiscover",

  // Link shortener
  "go",

  // Phone system
  "phone",
  "sip",
  "sip.dev",
  "sip.staging",

  /** Stiply (@deprecated) */
  "ondertekenen",
  "ondertekenen-test",

  // Automation
  "rpa",
]

// Reserved slugs that cannot be used as practice slugs to prevent routing
// conflicts
const RESERVED_SLUGS_ARRAY = [
  // National search functionality
  NATIONAL_SLUG,

  ...RESERVED_DOMAINS_ARRAY,

  // Care group functionality
  "zorggroep", // Care group domain in subdomain mode
  "z", // Care group prefix path

  // Static routes that exist on practice domains
  "about",
  "privacy",
  "contact",
  "login",

  // Route prefixes
  "portal",
  "auth",
  "app",
  "dashboard",
  "help",
  "support",
  "admin",

  // Additional reserved keywords
  "webflow",
  "zendesk",
  "zendeskverification",
] as const

export const RESERVED_SLUGS = new CiSet(RESERVED_SLUGS_ARRAY)

// IT-2451: The following hardcoded slugs are in use by MijnPraktijk/Buurtdokters
// and we use this list to limit certain functionality. For example, we ignore
// them for any Plato questionnaire statistics.
export const DEMO_ENVIRONMENT_SLUGS = ["buurtdokters", "platotest", "demo-sanday"]

export const NAME_MIN_LENGTH = 1
export const NAME_MAX_LENGTH = 255
